// Document Control — documents.* / document_categories.* / overview.documents
//
// Backend keys are registered by the amer-laravel migration
// 2026_08_28_000006_add_document_control_permissions.
//
// All eleven ids below are the **approval numbers issued by the central key
// service**, confirmed against the registry on 2026-08-27 (approved 2026-08-27).
// `createAndGrantToOwners` takes each `permissions.id` from that response, so an id
// here that does not equal its backend row fails silently — `HAS_PERMISSION` just
// returns false, and the page, the sidebar leaf and every gated button never appear
// with no message anywhere. Re-confirm against the registry rather than inferring
// the next number if a key is ever re-registered.

/** documents.index — the register; also gates the detail view (no `.show` key). */
export const DOCUMENTS_INDEX = 1501;
/** documents.create */
export const DOCUMENTS_CREATE = 1502;
/**
 * documents.update — also covers renew, archive and unarchive. All three change
 * the record the same way the edit form does, so they are not separate keys.
 */
export const DOCUMENTS_UPDATE = 1503;
/** documents.delete — also gates deleting one version (the module's one hard delete). */
export const DOCUMENTS_DELETE = 1504;
/** documents.restore */
export const DOCUMENTS_RESTORE = 1505;

/** document_categories.index */
export const DOCUMENT_CATEGORIES_INDEX = 1506;
/** document_categories.create */
export const DOCUMENT_CATEGORIES_CREATE = 1507;
/** document_categories.update */
export const DOCUMENT_CATEGORIES_UPDATE = 1508;
/** document_categories.delete */
export const DOCUMENT_CATEGORIES_DELETE = 1509;
/** document_categories.restore */
export const DOCUMENT_CATEGORIES_RESTORE = 1510;

/** overview.documents — the cockpit page with the compliance health meter. */
export const OVERVIEW_DOCUMENTS_INDEX = 1511;
